export default function HakkimizdaDetailed() {
  return (
    <>
      {/* ── Görünmek Yetmez ── */}
      <section className="section-padding bg-background-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="text-primary-500 font-bold text-sm tracking-[0.2em] uppercase mb-4">
            HAKKIMIZDA
          </p>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl text-foreground-50 tracking-tighter mb-8">
            Görünmek Yetmez
          </h2>

          <p className="text-base md:text-lg text-foreground-200 leading-relaxed mb-6 speakable-summary">
            Hiçbir toplantıda açıkça söylenmez ama gerçek şu:{' '}
            <strong>Reklam bütçesi harcamak, büyümekle aynı şey değildir.</strong>{' '}
            BIFF Digital, bu ayrımı gördüğümüz için 2021'de İzmir'de kuruldu — endüstriyel firmalardan e-ticaret markalarına, B2B şirketlerin yalnızca görünür olmasını değil, doğru insanlar tarafından doğru şekilde anlaşılmasını ve büyümesini sağlıyoruz.
          </p>

          <p className="text-sm md:text-base text-foreground-400 leading-relaxed mb-8">
            Dijital pazarlama, performans pazarlaması, reklam yönetimi, marka stratejisi, yaratıcı üretim, web geliştirme, SEO, veri analitiği ve nöropazarlama — bunları ayrı hizmetler olarak satmıyoruz. Tek bir büyüme sistemi içinde kuruyoruz.
          </p>

          <div className="glass-card rounded-2xl p-6 md:p-8 mb-8">
            <p className="text-lg md:text-xl font-bold text-foreground-100 mb-6 text-center tracking-tight">
              Growth + Strategy + Execution
            </p>
            <div className="space-y-4 text-sm md:text-base text-foreground-400 leading-relaxed">
              <p>Bir markanın neden büyümediğini anlamadan reklam bütçesini artırmayız.</p>
              <p>Müşterinin markayı nasıl algıladığını anlamadan iletişim stratejisi kurmayız.</p>
              <p>Veriyi okumadan kreatif üretmeyiz.</p>
              <p>Stratejiyi uygulamaya geçirmeden rapor hazırlayıp kenara çekilmeyiz.</p>
            </div>
          </div>
        </div>
      </section>

      {/* ── Ne Yapıyoruz? ── */}
      <section className="section-padding bg-background-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="text-primary-500 font-bold text-sm tracking-[0.2em] uppercase mb-4 text-center">
            YETKİNLİKLERİMİZ
          </p>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl text-foreground-50 tracking-tighter mb-4 text-center">
            Ne Yapıyoruz?
          </h2>
          <p className="text-sm md:text-base text-foreground-400 font-medium max-w-3xl mx-auto text-center mb-12 md:mb-16">
            BIFF Digital olarak markaların büyüme süreçlerini uçtan uca yönetiyoruz. Özellikle <strong>endüstriyel firmalar</strong> ve <strong>e-ticaret markaları</strong> için, dört başlık altında çalışıyoruz — ama bunlar bizim için dört ayrı departman değil, tek sistemin dört parçası.
          </p>

          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
            {[
              {
                icon: 'ri-line-chart-line',
                title: 'Growth',
                desc: 'Performans pazarlaması, paid media (Google Ads, Meta Ads), SEO, CRO (dönüşüm oranı optimizasyonu), analytics ve funnel sistemleri.',
                gradient: 'from-primary-500/20 to-accent-500/20',
              },
              {
                icon: 'ri-megaphone-line',
                title: 'Campaigns',
                desc: 'Marka lansmanları, yüksek etkili kampanyalar, siyasi iletişim, narrative management ve itibar yönetimi.',
                gradient: 'from-accent-500/20 to-secondary-500/20',
              },
              {
                icon: 'ri-paint-brush-line',
                title: 'Creative',
                desc: 'Marka stratejisi, branding, içerik stratejisi, yaratıcı kampanya ve prodüksiyon.',
                gradient: 'from-secondary-500/20 to-primary-500/20',
              },
              {
                icon: 'ri-server-line',
                title: 'Infrastructure',
                desc: 'Web geliştirme, yazılım çözümleri, yapay zekâ sistemleri, otomasyon ve veri altyapıları.',
                gradient: 'from-primary-500/20 to-secondary-500/20',
              },
            ].map((pillar, idx) => (
              <div key={idx} className="glass-card-hover rounded-2xl p-6 md:p-7 group relative overflow-hidden">
                <div className={`absolute inset-0 bg-gradient-to-br ${pillar.gradient} opacity-0 group-hover:opacity-100 transition-opacity duration-500`} />
                <div className="relative z-10">
                  <div className="w-12 h-12 bg-background-200 rounded-xl flex items-center justify-center mb-4 group-hover:bg-primary-500/10 transition-colors">
                    <i className={`${pillar.icon} text-xl text-primary-500`} />
                  </div>
                  <h3 className="text-lg md:text-xl font-bold text-foreground-50 mb-3">{pillar.title}</h3>
                  <p className="text-sm text-foreground-400 leading-relaxed">{pillar.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── BIFF Neden Farklı? ── */}
      <section className="section-padding bg-background-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="text-primary-500 font-bold text-sm tracking-[0.2em] uppercase mb-4">
            FARKIMIZ
          </p>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl text-foreground-50 tracking-tighter mb-8">
            BIFF Neden Farklı?
          </h2>

          <p className="text-base md:text-lg text-foreground-200 leading-relaxed mb-8">
            Çünkü yalnızca &quot;reklamınız çalışıyor mu?&quot; diye sormuyoruz.
          </p>

          <div className="glass-card rounded-2xl p-6 md:p-8 mb-8">
            <div className="space-y-3 text-sm md:text-base text-foreground-400 leading-relaxed">
              <p>Markanız nasıl algılanıyor?</p>
              <p>Müşteri sizi neden tercih ediyor?</p>
              <p>Reklam doğru kişiye doğru mesajı taşıyor mu?</p>
              <p>Web siteniz güven oluşturuyor mu?</p>
              <p>Trafik satışa dönüşüyor mu?</p>
              <p>Veri bize ne söylüyor?</p>
            </div>
          </div>

          <p className="text-sm md:text-base text-foreground-400 leading-relaxed mb-4">
            Bazen sorun reklam değildir.
            Bazen mesajdır.
            Bazen konumlandırmadır.
            Bazen kullanıcı deneyimidir.
            Bazen de markanın kendisini nasıl anlattığıdır.
          </p>

          <div className="glass-card rounded-2xl p-6 md:p-8 bg-gradient-to-r from-primary-500/5 to-accent-500/5">
            <p className="text-base md:text-lg font-bold text-foreground-100">
              BIFF'in işi, büyümenin nerede tıkandığını bulmak ve sistemi oradan yeniden kurmaktır.
            </p>
          </div>
        </div>
      </section>

      {/* ── Veri Yetmez. İnsan da Yetmez. ── */}
      <section className="section-padding bg-background-100">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="text-primary-500 font-bold text-sm tracking-[0.2em] uppercase mb-4">
            METODOLOJİ
          </p>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl text-foreground-50 tracking-tighter mb-8">
            Veri Yetmez. İnsan da Yetmez.
          </h2>

          <p className="text-base md:text-lg text-foreground-200 leading-relaxed mb-6">
            BIFF Digital, veriyle kreatifi, pazarlama zekâsıyla kullanıcı psikolojisini aynı masada buluşturur.
          </p>

          <p className="text-sm md:text-base text-foreground-400 leading-relaxed mb-8">
            Nöropazarlama ve beyin haritalama çalışmalarımızda gerçek kullanıcı tepkilerini EEG ve biyometrik ölçümler üzerinden, uzman nörologlar eşliğinde analiz ediyoruz.
          </p>

          <div className="glass-card rounded-2xl p-6 md:p-8 bg-gradient-to-r from-accent-500/5 to-primary-500/5">
            <p className="text-sm md:text-base text-foreground-400 leading-relaxed mb-4">
              Çünkü insanların söyledikleri ile davranışları her zaman aynı değildir.
            </p>
            <p className="text-base md:text-lg font-bold text-foreground-100">
              Biz yalnızca ne söylediklerine değil, nasıl tepki verdiklerine bakıyoruz.
            </p>
          </div>
        </div>
      </section>

      {/* ── Ankara'dan Türkiye Geneline ── */}
      <section className="section-padding bg-background-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="text-primary-500 font-bold text-sm tracking-[0.2em] uppercase mb-4">
            KONUM
          </p>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl text-foreground-50 tracking-tighter mb-8">
            Ankara'dan Türkiye Geneline
          </h2>

          <p className="text-base md:text-lg text-foreground-200 leading-relaxed mb-6">
            BIFF Digital, <strong>Söğütözü, Çankaya/Ankara</strong> merkezli operasyonlarıyla; özellikle <strong>endüstriyel firmalar</strong> ve <strong>e-ticaret markaları</strong> başta olmak üzere Ankara, İstanbul ve İzmir'deki B2B şirketlerle çalışır. Ulusal ve uluslararası ölçekte büyümek isteyen şirketlere de aynı sistemle hizmet veriyoruz.
          </p>

          <p className="text-sm md:text-base text-foreground-400 leading-relaxed mb-8">
            Ölçeklenmek isteyen markalar, teknoloji şirketleri, yazılım girişimleri, üretim şirketleri, yüksek büyüme hedefleyen işletmeler ve büyük kampanyalara ihtiyaç duyan organizasyonlar için strateji, kreatif, medya ve teknoloji ekiplerini aynı sistem içinde buluşturuyoruz.
          </p>

          <p className="text-sm md:text-base text-foreground-400 leading-relaxed mb-4">
            Hedefimiz daha fazla içerik üretmek ya da daha fazla reklam göstermek değil.
          </p>

          <div className="glass-card rounded-2xl p-6 md:p-8 mb-8">
            <div className="space-y-2 text-sm md:text-base text-foreground-400 leading-relaxed">
              <p>Daha büyük işler üretmek.</p>
              <p>Daha doğru kararlar almak.</p>
              <p>Daha sürdürülebilir büyüme yaratmak.</p>
            </div>
          </div>

          <div className="glass-card rounded-2xl p-6 md:p-8 bg-gradient-to-r from-primary-500/5 to-accent-500/5 text-center">
            <p className="text-lg md:text-xl font-bold text-foreground-100 mb-2">
              Görünmek yetmez. Doğru algılanmak gerekir.
            </p>
            <p className="text-sm text-foreground-400">
              BIFF Digital — Ankara Dijital Pazarlama Ajansı
            </p>
            <p className="text-sm font-bold text-primary-500 mt-1">
              Growth + Strategy + Execution
            </p>
          </div>
        </div>
      </section>
    </>
  );
}